import { MsalAuthProvider, LoginType } from 'react-aad-msal'
export const authProvider = new MsalAuthProvider(
  {
    auth: {
      authority: 'https://login.microsoftonline.com/common',
      clientId: process.env.REACT_APP_CLIENT_ID,
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
      validateAuthority: true,
      navigateToLoginRequestUrl: false
    }
  },
  {
    scopes: ['openid']
  },
  {
    loginType: LoginType.Redirect,
    tokenRefreshUri: window.location.origin + '/auth.html'
  }
)
